import { cn, type PropsWithClassName } from "@/components/podkit/lib/cn";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import React, { type PropsWithChildren, type ReactElement } from "react";

export function Tooltip({
    children,
    content,
    delayDuration,
    align = "center",
    alignOffset,
    side,
    sideOffset,
    usePortal = false,
    inverted = true,
    className,
    avoidCollisions = true,
    collisionPadding,
}: PropsWithChildren &
    PropsWithClassName & {
        content?: string | ReactElement;
        delayDuration?: number;
        align?: "center" | "start" | "end";
        alignOffset?: number;
        side?: "top" | "right" | "bottom" | "left";
        sideOffset?: number;
        usePortal?: boolean;
        /**
         * @deprecated use a custom className instead
         */
        inverted?: boolean;
        avoidCollisions?: boolean;
        collisionPadding?: number | { top?: number; right?: number; bottom?: number; left?: number };
    }) {
    const Wrapper = usePortal ? TooltipPrimitive.Portal : React.Fragment;

    return (
        <TooltipPrimitive.Provider delayDuration={delayDuration ?? 500}>
            <TooltipPrimitive.Root>
                <TooltipPrimitive.Trigger asChild>{children}</TooltipPrimitive.Trigger>
                {content && (
                    <Wrapper>
                        <TooltipPrimitive.Content
                            side={side}
                            align={align}
                            alignOffset={alignOffset}
                            sideOffset={sideOffset}
                            avoidCollisions={avoidCollisions}
                            collisionPadding={collisionPadding}
                            className={cn(
                                "group z-50 m-4 rounded-md px-3 py-2 text-sm",
                                inverted
                                    ? "bg-surface-tooltip-primary text-content-tooltip"
                                    : "border border-border-base bg-surface-01 text-content-primary",
                                className,
                            )}
                            data-component="tooltip"
                            hideWhenDetached={true}
                        >
                            {content}
                        </TooltipPrimitive.Content>
                    </Wrapper>
                )}
            </TooltipPrimitive.Root>
        </TooltipPrimitive.Provider>
    );
}
